import React from 'react';

/**
 * SkipToContent - Accessibility skip link for keyboard navigation
 */
const SkipToContent = ({ targetId = 'main-content', label = 'Skip to main content' }) => {
  return (
    <a
      href={`#${targetId}`}
      className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:bg-purple-600 focus:text-white focus:rounded-lg focus:font-semibold focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2"
      onClick={(e) => {
        e.preventDefault();
        const element = document.getElementById(targetId);
        if (element) {
          element.focus();
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }}
    >
      {label}
    </a>
  );
};

export default SkipToContent;
